import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["classification", "stepsSection"];

  connect() {
    this.toggleStepsSection();
  }

  toggleStepsSection() {
    if (!this.hasClassificationTarget || !this.hasStepsSectionTarget) {
      return;
    }

    const classification = this.classificationTarget.value;
    const isCustomerComplaint = classification === "customer_complaint";

    this.stepsSectionTarget.style.display = isCustomerComplaint ? "block" : "none";
  }
}
